import { ItemData } from 'core/models/Template'

export const SAMSONITE_CATALOG_TITLE_KEY = 'samsoniteCatalog' as const

export type SamsoniteSelectedItems = ItemData[]
